module.exports = __webpack_public_path__ + "static/yellowpaper_en-8ac96b06f39f19a6a28106cf624e3342.pdf";